export default __webpack_public_path__ + "static/media/december.68a6f6d4.svg";